
import LayoutContainer from "@/components/layout/container.vue";
import { defineComponent } from "vue";
import { useLayoutStore } from "@/stores/layoutStore";
import { useApiStore } from "@/stores/apiStore";
import { storeToRefs } from "pinia";
import { useSiteStore } from "@/stores/siteStore";
import { useViewStore } from "@/stores/ssaStore/views";
import { useSsaStore } from "@/stores/ssaStore";
import { useWslinkStore } from "@/stores/ssaStore/wslink";
import { usePanelStore } from "@/stores/panelStore";
export default defineComponent({
	setup() {
		const layoutStore = useLayoutStore();
		const wsLink = useWslinkStore();
		const api = useApiStore();
		const views = useViewStore();
		const siteStore = useSiteStore();
		const ssaStore = useSsaStore();
		const { isDragging } = storeToRefs(layoutStore);
		const { connectionError } = storeToRefs(useWslinkStore());
		const { PANELS_READY: panelsReady } = storeToRefs(usePanelStore());

		return {
			wsLink,
			ssaStore,
			layoutStore,
			api,
			views,
			siteStore,
			isDragging,
			panelsReady,
			connectionError
		};
	},
	name: "SSA",
	components: {
		LayoutContainer
	},
	data() {
		return {
			resetLoading: false,
			isLoading: true,
			errorMessage: this.$t(`ssaVueWindows.errorMsg`)
		};
	},

	computed: {
		panelLayout(): LayoutType {
			return this.layoutStore.panelLayout;
		},
		rootLayout() {
			return {
				componentName: "Root",
				type: "root",
				id: 0,
				componentState: {
					flex: 1,
					lastFlex: 1
				},
				children: [
					{
						id: 1234,
						componentName: "LEFT",
						type: "column",
						componentState: {
							flex: 1,
							lastFlex: 1
						},
						children: [
							{
								id: 1,
								type: "stacked",
								componentName: "1",
								componentState: {
									flex: 1,
									lastFlex: 1
								},
								children: [
									{
										id: 2,
										componentName: "Data Tree",
										type: "component",
										component: "Hierarchy",
										componentState: {
											flex: 1,
											color: "#fff",
											lastFlex: 1
										}
									}
								]
							}
							// {
							// id:16,
							// type:'stacked',
							// componentName:'1',
							// componentState:{
							//     flex:1,
							//     lastFlex:1
							// },
							// children:[
							//     {
							//     id:14,
							//     componentName:'Control Panel',
							//     type:'component',

							//     component:'DefaultComponent',
							//     componentState:{
							//         flex:1,
							//         color:'#fff',
							//         lastFlex:1
							//     }
							//     },
							// ]
							// },
						]
					},
					{
						id: 4,
						type: "column",
						componentName: "MIDDLE",
						componentState: {
							flex: 3,
							lastFlex: 3
						},
						children: [
							{
								id: 5,
								componentName: "Visualizer",
								type: "component",
								component: "Visualizer",
								componentState: {
									flex: 1,
									color: "#fff",
									lastFlex: 1
								}
							}
						]
					},
					{
						id: 8,
						type: "stacked",
						componentName: "1",
						componentState: {
							flex: 1,
							lastFlex: 1
						},
						children: [
							{
								id: 9,
								componentName: "Display",
								type: "component",
								component: "DisplayPane",
								componentState: {
									flex: 1,
									color: "#fff",
									lastFlex: 1
								}
							}
						]
					}
				]
			} as LayoutType;
		},
		layout(): any {
			return {
				componentName: "Root",
				type: "root",
				id: 0,
				componentState: {
					flex: 1,
					lastFlex: 1
				},
				children: [
					{
						id: 1234,
						componentName: "",
						type: "column",
						componentState: {
							flex: 1,
							lastFlex: 1
						},
						children: [
							{
								id: 1,
								type: "stacked",
								componentName: "1",
								componentState: {
									flex: 1,
									lastFlex: 1
								},
								children: [
									{
										id: 2,
										componentName: "Data Tree",
										type: "component",
										component: "Hierarchy",
										componentState: {
											flex: 1,
											color: "#fff",
											lastFlex: 1
										}
									}
								]
							}
							// {
							// id:16,
							// type:'stacked',
							// componentName:'1',
							// componentState:{
							//     flex:1,
							//     lastFlex:1
							// },
							// children:[
							//     {
							//     id:14,
							//     componentName:'Control Panel',
							//     type:'component',

							//     component:'DefaultComponent',
							//     componentState:{
							//         flex:1,
							//         color:'#fff',
							//         lastFlex:1
							//     }
							//     },
							// ]
							// },
						]
					},
					{
						id: 4,
						type: "stacked",
						componentName: "4",
						componentState: {
							flex: 3,
							lastFlex: 3
						},
						children: [
							{
								id: 5,
								componentName: "3D View",
								type: "component",
								component: "Visualizer",
								componentState: {
									flex: 1,
									color: "#fff",
									lastFlex: 1
									// viewId:this.views.viewIds[0] || 0,
								}
							}
						]
					},
					{
						id: 8,
						type: "stacked",
						componentName: "1",
						componentState: {
							flex: 1,
							lastFlex: 1
						},
						children: [
							{
								id: 9,
								componentName: "Inspector",
								type: "component",
								component: "DefaultComponent",
								componentState: {
									flex: 1,
									color: "#fff",
									lastFlex: 1
								}
							}
						]
					}
				]
			} as LayoutType;
		}
	},
	methods: {
		setPanelLayout(payload: LayoutType) {
			this.layoutStore.SET_PANEL_LAYOUT(payload);
		},

		resizeContainer() {
			this.$nextTick(() => {
				const ro: any = new ResizeObserver(() => {
					if ((this.$refs.layoutContainer as any) != null) {
						(this.$refs.layoutContainer as any).redrawHandles();
					}
				});

				// Observe one or multiple elements
				ro.observe(this.$refs.main);
			});
		}
	},
	mounted() {
		if (!this.panelsReady && localStorage.getItem("sessionUrl") != null) {
			try {
				this.wsLink.SSA_REQUEST_NEW_PARAVIEW(false);
				this.isLoading = false;
			} catch (e) {
				console.log(e);
			}
		}
	},
	watch: {
		panelLayout: {
			deep: true,
			handler(v: LayoutType) {
				localStorage.setItem("layout", JSON.stringify(v));
			}
		},
		async panelsReady() {
			this.setPanelLayout(this.rootLayout);
			if (!this.wsLink.WSLINK_CONNECTING) {
				try {
					this.wsLink.SSA_REQUEST_NEW_PARAVIEW(false);
				} catch (e) {
					console.log("error here 2");
				}
			}
		}
	}
});
